import { t } from '@/helpers/i18n';
import authApi from '@/services/auth';
import dataApi from '@/services/data';
import { event } from 'vue-analytics';
const mutations = {
    setState(state, val) {
        if (typeof val == 'object' && val.val) {
            state.state = t(val.val) + (val.err ? ' ' + val.err : '');
        }
        else {
            state.state = String(t(val));
        }
    },
    clearState(state) {
        state.state = null;
    },
    setFBUser(state, val) {
        state.fbUser = val;
    },
    setFBToken(state, token) {
        state.fbToken = token;
        authApi.setFBToken(token);
    },
    setBEInfo(state, val) {
        dataApi.setToken(val.token);
        authApi.setBEToken(val.token);
        state.token = val.token;
        state.account = val.account;
        state.profile = val.profile;
        // profile mods
        const year = new Date().getFullYear();
        for (let p of val.profiles) {
            p.isAdult = (p.birth_year && year - p.birth_year > 17);
            state.profileByID[p.id] = p;
        }
        state.profiles = val.profiles;
        if (state.profile)
            state.profile.isAdult = state.profile.birth_year ? year - Number(state.profile.birth_year) > 17 : false;
        // session timeout
        const split = String(val.token).split('.');
        if (split.length > 2) {
            const ob = JSON.parse(atob(split[1]));
            state.sessionTimeoutUnix = ob.exp;
        }
    },
    removeProfile(state, id) {
        state.profiles = state.profiles.filter((p) => p.id != id);
        delete state.profileByID[id];
    },
    logout(state) {
        event('auth-store', 'logout');
        state.account = null;
        state.token = null;
        state.profile = null;
        state.profiles = [];
        state.profileByID = {};
    }
};
export default mutations;
